import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { API_BASE_URL, loginDesarrollo, obtenerMetodosLogin } from "../api";

export default function Entrar() {
  const metodos = useQuery({ queryKey: ["metodos"], queryFn: obtenerMetodosLogin });
  const [mostrarDev, setMostrarDev] = useState(false);

  const urlLoginGoogle = `${API_BASE_URL}/login/google`;

  return (
    <div className="landing-contenedor">
      {/* Barra superior de navegación */}
      <header className="landing-barra">
        <div className="landing-barra-izq">
          <span className="landing-marca">
            Fichas Veterinarias
          </span>
          <span className="landing-pill-nav">
            Mis mascotas
          </span>
        </div>

        <div className="landing-barra-der">
          {metodos.data?.google ? (
            <a href={urlLoginGoogle} className="boton-landing-outline">
              Login con Google
            </a>
          ) : metodos.data?.desarrollo ? (
            <button
              type="button"
              className="boton-landing-outline"
              onClick={() => setMostrarDev(!mostrarDev)}
            >
              Login Desarrollador
            </button>
          ) : null}
        </div>
      </header>

      {/* Hero principal */}
      <main className="landing-hero-wrap">
        <div className="landing-hero-grid">
          {/* Columna Izquierda: Tarjeta Hero */}
          <section className="landing-card-hero">
            <div className="landing-tag-pill">
              <span>🧡</span> Fichas Veterinarias
            </div>

            <h1 className="landing-titulo">
              El mejor cuidado para <br />
              <span className="landing-titulo-destacado">tu mejor amigo</span>
            </h1>

            <p className="landing-descripcion">
              Olvídate de los papeles. Lleva el historial clínico, vacunas y citas de tus mascotas
              siempre contigo. Una experiencia única y personalizada para garantizar su bienestar.
            </p>

            <div className="landing-badges-features">
              <div className="landing-feature-badge">
                <span className="landing-check-icono">✓</span>
                <span>Recordatorios de vacunas</span>
              </div>
              <div className="landing-feature-badge">
                <span className="landing-check-icono">✓</span>
                <span>Historial médico</span>
              </div>
            </div>

            <div className="landing-acciones">
              {metodos.data?.google ? (
                <>
                  <a href={urlLoginGoogle} className="boton-landing-primario">
                    Ingresar
                  </a>
                  <a href={urlLoginGoogle} className="boton-landing-secundario">
                    Registrarse
                  </a>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="boton-landing-primario"
                    onClick={() => setMostrarDev(true)}
                  >
                    Ingresar
                  </button>
                  <button
                    type="button"
                    className="boton-landing-secundario"
                    onClick={() => setMostrarDev(true)}
                  >
                    Registrarse
                  </button>
                </>
              )}
            </div>

            <p className="landing-comunidad-pie">
              Únete a nuestra comunidad donde todas las mascotas son tratadas con el amor que merecen.
            </p>

            {metodos.data && !metodos.data.google && !metodos.data.desarrollo && (
              <p className="err" style={{ marginTop: "1rem" }}>
                Este despliegue no tiene ningún método de login configurado.
              </p>
            )}

            {/* Panel de login de desarrollo */}
            {metodos.data?.desarrollo && (
              <div className="landing-dev-toggle">
                <button
                  type="button"
                  className="boton-dev-link"
                  onClick={() => setMostrarDev(!mostrarDev)}
                >
                  {mostrarDev ? "▲ Ocultar login de desarrollo" : "🛠️ Acceso rápido para desarrollo"}
                </button>
                {mostrarDev && <LoginDesarrollo />}
              </div>
            )}
          </section>

          {/* Columna Derecha: Mockup Visual de Ficha Clínica */}
          <section className="landing-ilustracion-col">
            <div className="landing-circulo-resplandor" />
            <div className="mockup-ficha-tarjeta">
              <div className="mockup-ficha-cabecera">
                <div className="mockup-ficha-marca">
                  <span className="mockup-doc-titulo">FICHA VETERINARIA</span>
                </div>
                <div className="mockup-id-badge">HISTORIAL #01</div>
              </div>

              <div className="mockup-avatar-circulo">
                <div className="mockup-perro-ilustrado">
                  <span className="mockup-emoji-perro" role="img" aria-label="Mascota">🐶</span>
                </div>
                <div className="mockup-collar-tag">★</div>
              </div>

              <div className="mockup-ficha-datos">
                <div className="mockup-nombre-mascota">Bobby</div>
                <div className="mockup-raza-linea">Canino · Mestizo · 3 años · 12.4 kg</div>
              </div>

              <div className="mockup-tabla-clinica">
                <div className="mockup-fila-clinica">
                  <span className="mockup-punto-verde">●</span>
                  <span className="mockup-texto-fila">Vacuna Antirrábica</span>
                  <span className="mockup-estado-pill">Al día</span>
                </div>
                <div className="mockup-fila-clinica">
                  <span className="mockup-punto-verde">●</span>
                  <span className="mockup-texto-fila">Antiparasitario Interno</span>
                  <span className="mockup-estado-pill">Al día</span>
                </div>
                <div className="mockup-fila-clinica">
                  <span className="mockup-punto-verde">●</span>
                  <span className="mockup-texto-fila">Control Anual de Salud</span>
                  <span className="mockup-estado-pill">Completado</span>
                </div>
              </div>

              <div className="mockup-ficha-pie">
                <div className="mockup-codigo-barras">
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
                <div className="mockup-qr-mini">
                  <div className="mockup-qr-patron" />
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}

/** Sólo aparece si el backend declara que la puerta de desarrollo está abierta. */
function LoginDesarrollo() {
  const qc = useQueryClient();
  const [email, setEmail] = useState("dev@fichas.local");

  const entrar = useMutation({
    mutationFn: () => loginDesarrollo(email),
    onSuccess: () => qc.invalidateQueries(),
  });

  return (
    <div className="dev" style={{ marginTop: "0.75rem", borderTop: "none" }}>
      <h3>Login de desarrollo</h3>
      <p className="muted">
        Ingresa con un email para pruebas locales.
      </p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          entrar.mutate();
        }}
      >
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" className="boton-primario" disabled={entrar.isPending}>
          {entrar.isPending ? "Entrando…" : "Entrar"}
        </button>
      </form>
      {entrar.error && <p className="err">{entrar.error.message}</p>}
    </div>
  );
}
